import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SettingsPage = () => {
    const navigate = useNavigate();
    const [postPurchaseDiscount, setPostPurchaseDiscount] = useState("");
    const [backgroundColor, setBackgroundColor] = useState("red");
    const [textColor, setTextColor] = useState("red");
    const [discountType, setDiscountType] = useState("percentage"); // default value

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    // Fetch current setting when page loads
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("token");
                const res = await axios.get(process.env.REACT_APP_GET_SETTINGS, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (res.data?.data[0]?.post_purchase_discount) {
                    setPostPurchaseDiscount(res.data?.data[0]?.post_purchase_discount);
                    setBackgroundColor(res.data?.data[0]?.background_color);
                    setTextColor(res.data?.data[0]?.text_color)
                    setDiscountType(res.data?.data[0]?.discount_type)

                }
            } catch (err) {
                setError(err.response?.data?.message || "Failed to load settings");
            } finally {
                setLoading(false);
            }
        };

        fetchSettings();
    }, []);

    // Update settings API
    const handleUpdate = async (e) => {
        e.preventDefault();
        setMessage(null);
        setError(null);

        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            const res = await axios.post(
                process.env.REACT_APP_GET_SETTINGS,
                { post_purchase_discount: postPurchaseDiscount,
                    background_color: backgroundColor,
                    text_color: textColor,
                    discount_type: discountType
                 },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setMessage(res.data.message || "Settings updated successfully!");
            setTimeout(() => setMessage(null), 3000);
        } catch (err) {
            setError(err.response?.data?.message || "Failed to update settings");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="min-h-screen bg-gray-50 px-4 py-10 sm:px-6 lg:px-8">
            <div className="max-w-xl mx-auto bg-white rounded-lg shadow-md p-6">
                {/* Header */}
                <header className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-900">Settings</h2>
                    <button
                        onClick={() => navigate(-1)}
                        className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-300"
                    >
                        ← Back
                    </button>
                </header>

                {/* Alerts */}
                {message && <p className="text-green-600 text-sm mb-4">{message}</p>}
                {error && <p className="text-red-600 text-sm mb-4">{error}</p>}

                {/* Form */}
                <form onSubmit={handleUpdate}>
                    <div className="mb-5">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Post Purchase Discount Type
                        </label>
                        <select
                            value={discountType}
                            onChange={(e) => {
                                setDiscountType(e.target.value);
                                setPostPurchaseDiscount(""); // reset value when type changes
                            }}
                            className="w-full border border-gray-300 rounded-md px-3 py-2 mb-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="percentage">Percentage</option>
                            <option value="flat">Flat</option>
                        </select>
                    </div>
                    <div className="mb-5">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Post Purchase Discount
                        </label>
                        <input
                            type="number"
                            value={postPurchaseDiscount}
                            onChange={(e) => setPostPurchaseDiscount(e.target.value)}
                            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter discount "
                            min="0"
                            max="100"
                            required
                        />
                    </div>
                    {/* <div className="mb-5">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Background Color
                        </label>
                        <input
                            type="text"
                            value={backgroundColor}
                            onChange={(e) => setBackgroundColor(e.target.value)}
                            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter background color"
                            required
                        />
                    </div> */}
                    {/* <div className="mb-5">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Text Color
                        </label>
                        <input
                            type="text"
                            value={textColor}
                            onChange={(e) => setTextColor(e.target.value)}
                            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter text color"
                            required
                        />
                    </div> */}

                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full py-2 rounded-md transition ${
                            loading
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-blue-600 hover:bg-blue-700"
                        } text-white`}
                    >
                        {loading ? "Saving..." : "Update Settings"}
                    </button>
                </form>
            </div>
        </main>
    );
};

export default SettingsPage;
